export default {
  BUENOS_AIRES: 'America/Buenos_Aires'
}
